<template>
  <div>    
    <v-expansion-panels flat>
      <v-card width="100%" flat class="table-title pl-14">
        <v-row no-gutters>
          <v-col cols="3" class="">Arbetsgivare</v-col>
          <v-col cols="2" class="hidden-md-and-down">Yrke</v-col>
          <v-col cols="2" class="hidden-md-and-down">Omfattning</v-col>
          <v-col cols="1" class="hidden-md-and-down">Start</v-col>
          <v-col cols="1" class="hidden-md-and-down">Slut</v-col>
          <v-col cols="2" lg="2">Typ</v-col>
          <v-col cols="1" class="hidden-md-and-down"></v-col>
        </v-row>
      </v-card>

      <v-expansion-panel v-for="(item,i) in selectedPerson.apprenticeships" :key="`app-${i}`">
        <v-expansion-panel-header expand-icon="mdi-menu-down" class="arrow-leftside pa-0 d-flex align-center pr-6">
           <template v-slot:actions>
              <v-icon>mdi-menu-right</v-icon>
          </template>
          <v-row no-gutters class="d-flex align-center" :class="{'text-decoration-line-through': Boolean(item.manuallyEndedDate)}">
            <v-col cols="3"><b>{{ item.company && item.company.name || ''}}</b></v-col>
            <v-col cols="2" class="hidden-md-and-down">{{ item.profession && item.profession.name || '' }}</v-col>
            <v-col cols="2" class="hidden-md-and-down">{{ item.employmentType && item.employmentType.name || ''}}</v-col>
            <v-col cols="1" class="hidden-md-and-down">{{ item.fromDate | date }}</v-col>
            <v-col cols="1" class="hidden-md-and-down">{{ item.toDate | date }}</v-col>
            <v-col cols="2" lg="2">{{item.employmentType && item.employmentType.name || ''}}</v-col>
            <v-col cols="1"  class="hidden-md-and-down d-flex">
              <v-btn v-if="currentUser.userrole.isAdmin"
                text
                @click.native.stop="extendId=item.id; extendDate={ fromDate: item.fromDate, toDate: item.toDate }; showModal=true"
                :style="{marginRight: '-2rem'}"
                >
                <v-icon class="calendar">$sl-calendar-date</v-icon>
              </v-btn>

              <v-btn v-if="currentUser.userrole.isAdmin"
                text
                @click.native.stop="deleteEmployment(item.id, 1)">
                <v-icon>$sl-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pl-11">
          <template v-if="item.workplaces && item.workplaces.length">
            <v-row no-gutters v-for="(wp,j) in item.workplaces" :key="`emp-${j}`">
              <v-col cols="2">
                <p class="employment-title" v-if="j===0">ARBETSPLATS(ER)</p>
              </v-col>
              <v-col
                cols="10"
              >{{ wp.workplaceaddress && wp.workplaceaddress.name || ''}}, {{ wp.workplaceaddress && wp.workplaceaddress.postalAddress1 || ''}}, {{ wp.workplaceaddress && wp.workplaceaddress.postalCity || ''}}</v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row no-gutters>
              <v-col cols="2">
                <p class="employment-title">ARBETSPLATS</p>
              </v-col>
              <v-col
                cols="10"
              >{{ item.company && item.company.name || ''}}, {{ item.company && item.company.postalAddress1 || ''}}, {{item.company && item.company.postalCity || ''}}</v-col>
            </v-row>
          </template>
          <template v-for="(inst, index) in item.apprenticeshipInstructors">
            <v-row no-gutters :key="`instructor-rc1-${index}`">
              <v-col cols="2">
                <p class="employment-title">HANDLEDARE</p>
              </v-col>
              <v-col cols="2">
                <router-link
                  :to="'/people/' + get(inst, 'instructor.employed.id', '')"
                >{{ get(inst, 'instructor.employed.firstName', '') }} {{ get(inst, 'instructor.employed.lastName', '') }}</router-link>
              </v-col>
            </v-row>

            <v-row no-gutters :key="`instructor-rc3-${index}`">
              <v-col cols="2" class="employment-title mt-n2 pl-3">Yrkesbevis</v-col>
              <v-col cols="9" class="mt-n2">
                <template
                  v-if="get(inst, 'instructor.employed.tradeCertificates', []).length"
                >{{ get(inst, 'instructor.employed.tradeCertificates', []).map(o => { return o.profession ? o.profession.name : ''}).join(',') }}</template>
                <template v-else>Inga yrkesbevis registrerade</template>
              </v-col>
            </v-row>
            <v-row no-gutters :key="`instructor-rc4-${index}`">
              <v-col cols="2" class="employment-title pl-3 pt-1">Mobilnummer</v-col>
              <v-col cols="10">{{ get(inst, 'instructor.employed.mobilephone', '') }}</v-col>
            </v-row>
            <v-row no-gutters :key="`instructor-rc5-${index}`">
              <v-col cols="2" class="employment-title pl-3 pt-1">E-postadress</v-col>
              <v-col cols="10">
                <a
                  :href="`mailto:${get(inst, 'instructor.employed.email', '')}`"
                >{{ get(inst, 'instructor.employed.email', '') }}</a>
              </v-col>
            </v-row>
            <v-row no-gutters :key="`instructor-rc6-${index}`">
              <v-col cols="10" class="my-8">
                <v-btn
                  color="secondary"
                  @click="$router.push({name: 'Company', params: {id: item.company.id}})"
                >
                  <v-icon>$sl-bulding-day-light</v-icon>Visa företaget
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-for="(item,i) in selectedPerson.employments" :key="`emp-${i}`">
        <v-expansion-panel-header expand-icon="mdi-menu-down" class="arrow-leftside">
          <template v-slot:actions>
            <v-icon>mdi-menu-right</v-icon>
          </template>
          <v-row no-gutters>
            <v-col cols="3">
              <b>{{ item.company && item.company.name || ''}}</b>
            </v-col>
            <v-col
              cols="2"
              class="hidden-md-and-down"
            >{{ item.profession && item.profession.name || ''}}</v-col>

            <v-col
              cols="2"
              class="hidden-md-and-down"
            >{{ getEmploymentTypeNameById(Number(item.employmentTypeId)) }}</v-col>
            <v-col cols="1" class="hidden-md-and-down">{{item.fromDate | date}}</v-col>
            <v-col cols="1" class="hidden-md-and-down">{{item.toDate | date}}</v-col>
            <v-col cols="8" lg="2">{{ (item.roleDescription || '')}}</v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="item.workplaces && item.workplaces.length">
            <v-row no-gutters v-for="(wp,j) in item.workplaces" :key="`emp-${j}`">
              <v-col cols="2">
                <p v-if="j===0" class="employment-title">ARBETSPLATS(ER)</p>
              </v-col>
              <v-col
                cols="10"
              >{{ wp.workplaceaddress && wp.workplaceaddress.name || ''}}, {{ wp.workplaceaddress && wp.workplaceaddress.postalAddress1 || ''}}, {{ wp.workplaceaddress && wp.workplaceaddress.postalCity || ''}}</v-col>
            </v-row>
          </template>
          <template v-if="item.apprenticeshipInstructors && item.apprenticeshipInstructors.length">
            <v-row no-gutters>
              <v-col cols="2">
                <p class="employment-title">LÄRLINGAR</p>
              </v-col>
            </v-row>
            <template v-for="(a,k) in item.apprenticeshipInstructors">
            <!-- Filter out apprenticeships that has been disconnected -->
              <template v-if="! a.apprenticeship.manuallyEndedDate">
                <v-row no-gutters :key="`empapp-${k}-name`" class="mt-n4">
                  <v-col cols="2" class="employment-subtitle">Namn</v-col>
                  <v-col cols="10">
                    <router-link
                      :to="'/people/' + a.apprenticeship.apprentice.id"
                    >{{ a.apprenticeship.apprentice.firstName }} {{ a.apprenticeship.apprentice.lastName }}</router-link>
                  </v-col>
                </v-row>
                <v-row no-gutters :key="`empapp-${k}-profession`">
                  <v-col cols="2" class="employment-subtitle">Yrke</v-col>
                  <v-col cols="10">{{ a.apprenticeship.profession.name || ''}}</v-col>
                </v-row>
                <v-row no-gutters :key="`empapp-${k}-time`">
                  <v-col cols="2" class="employment-subtitle">Period</v-col>
                  <v-col cols="10">{{ a.fromDate | date }} - {{ a.toDate | date }}</v-col>
                </v-row>
                <v-row no-gutters :key="`empapp-${k}-mobile`">
                  <v-col cols="2" class="employment-subtitle">Mobilnummer</v-col>
                  <v-col cols="10">{{ a.apprenticeship.apprentice.mobilephone }}</v-col>
                </v-row>
                <v-row no-gutters :key="`empapp-${k}-email`">
                  <v-col cols="2" class="employment-subtitle mb-8">E-postadress</v-col>
                  <v-col cols="10">{{ a.apprenticeship.apprentice.email }}</v-col>
                </v-row>
              </template>
            </template>
          </template>
          <v-row no-gutters>
            <v-col cols="10" class="mb-8">
              <v-btn
                color="secondary"
                @click="$router.push({name: 'Company', params: {id: item.companyId}})"
              >
                <v-icon>$sl-bulding-day-light</v-icon>Visa företaget
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <ExtendApprenticeshipModal
      :show="showModal"
      :appId="extendId"
      :currentDate="extendDate"
      @close="showModal=false"
      @saved="showModal=false; $emit('saved')"/>
  </div>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import ExtendApprenticeshipModal from '@/components/person/ExtendApprenticeshipModal'
import get from 'lodash/get'

// @group Person
// PersonEmployments component
export default {
  name: 'PersonEmployments',

  data: () => ({
    showModal: false,
    extendId: null,
    extendDate: null
  }),

  components: {
    ExtendApprenticeshipModal
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('basic', ['getEmploymentTypeNameById', 'basicEmploymentTypes']),
    ...mapGetters('currentuser', ['currentUser']),

    setRowLineThrough(item) {
      const isDisconnected = this.selectedPerson.apprenticeships?.find(apprenticeship => {
        return apprenticeship.id === item.id && item.manuallyEndedDate
      })

      return isDisconnected ? 'text-decoration-line-through' : ''
    },

  },

  methods: {
    get,

    showExtendModal(e) {
      console.log(e)
      e.stopPropagation()
      this.extendId = -1 //app.id
      this.showModal = true
    },

    async deleteEmployment(employmentId, employmentType) {
      if ( !employmentId || !employmentType ) return
      const apiMethod = { 1: 'deleteApprenticeship' , 2: 'deleteEmployment' }

      try {
        const res = await this.$dialog.confirm({
          text: 'OBS! Radering av anställning går inte att ångra.',
          title: 'Radera anställning',
          actions: [
            {text: 'Avbryt', key: false, icon: '$sl-cancel'},
            {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
          ]
        })

        if (res !== true) return

        await API[apiMethod[employmentType]](employmentId)
        this.$emit('saved')
        this.$events.fire('showInfo', 'Anställning raderad.')
      } catch (error) {
        this.$events.fire('showError', 'Kunde tyvärr inte radera anställningen.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
